/**
 * PandaDoc's square mark on its own.
 *
 * `Pandadoc` is the full 103x24 wordmark. Integration cards pair a square logo
 * with the provider name as text, so a wordmark there prints the name twice and
 * sizes differently from every other logo on the page. These are the mark's two
 * paths lifted out of that wordmark — the green tile and the white monogram —
 * shifted to sit at the origin of a 24x24 box.
 */
const SvgPandadocLogo = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-0.519531 0)">
      <path d="M0.519531 0H24.538V24H0.519531V0Z" fill="#248567" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1327 8.75032L18.0721 8.78072C17.5575 8.35477 16.8914 8.08096 16.0437 8.08096C14.9538 8.08096 13.9547 8.47648 13.2886 9.26754L14.318 10.3628C14.8327 9.87604 15.3776 9.60222 16.074 9.60222C17.3758 9.63263 18.2235 10.6367 18.2235 11.9754C18.2235 13.3141 17.3455 14.3485 16.0134 14.3485C12.6831 14.3485 13.6217 8.08096 9.1409 8.08096C6.9005 8.08096 5.32617 9.75433 5.32617 11.9754V18.7601H6.93079V15.1396L6.99134 15.1091C7.50602 15.5351 8.17207 15.8089 9.0198 15.8089C10.1097 15.8089 11.1088 15.4134 11.7749 14.6223L10.7455 13.527C10.2308 14.0139 9.68584 14.2877 8.98951 14.2877C7.68768 14.2572 6.83995 13.2532 6.83995 11.9145C6.83995 10.5758 7.71794 9.54136 9.05006 9.54136C12.3804 9.54136 11.4418 15.8089 15.9226 15.8089C18.163 15.8089 19.7373 14.1355 19.7373 11.9145V5.16016H18.1327V8.75032Z"
        fill="white"
      />
    </g>
  </svg>
);
export default SvgPandadocLogo;
